import { render, staticRenderFns } from "./DiagnosticTestHistory.vue?vue&type=template&id=266b3cc1&scoped=true&"
import script from "./DiagnosticTestHistory.vue?vue&type=script&lang=js&"
export * from "./DiagnosticTestHistory.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticTestHistory.vue?vue&type=style&index=0&id=266b3cc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266b3cc1",
  null
  
)

export default component.exports